/**
 * Resolve a CDN-relative image path against the country's own CDN, carried in
 * the goGlobal island as CDN_URL (constants.cdnPath server-side — see
 * src/shared/constants.service.ts). An already-absolute url passes through
 * unchanged, so a caller can mix admin-supplied absolute urls with bare
 * filenames without checking which it has.
 */
export function assetUrl(image) {
  if (!image) return '';
  if (/^(https?:)?\/\//i.test(image)) return image;
  const cdn = ((window.goGlobal || {}).CDN_URL || '').replace(/\/+$/, '');
  return `${cdn}/${String(image).replace(/^\/+/, '')}`;
}
